import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase-config";
import { AuthContext } from "../context/AuthContext";
import "../styles/navbar.css";
const Navbar = () => {
  const { user } = useContext(AuthContext);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      alert("Successfully signed out!");
    } catch (error) {
      alert("Error signing out: " + error.message);
    }
  };

  return (
    <nav >
      <Link to="/">Home</Link>
      <Link to="/createpost">Create Post</Link>
      {user ? (
        <>
          
          <Link to="/dashboard">
          <div className="user-info">
            {/* Display User Name */}
            <span>{user.displayName || "User"}</span>
          </div>
          </Link>
          <button onClick={handleSignOut}>Sign Out</button>
        </>
      ) : (
        <>
          <Link to="/login">Login</Link>
          <Link to="/signup">Sign Up</Link> {/* Add Sign Up link */}
        </>
      )}
    </nav>
  );
};

export default Navbar;
